<template>
  <b-jumbotron>
    <b-container>
      <b-row>
        <b-col>
          <h1>{{ title }}</h1>
          <p>{{ subtitle }}</p>
        </b-col>
        <b-col class="text-right">
          <slot name="col-right" />
        </b-col>
      </b-row>
    </b-container>
  </b-jumbotron>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>
